import Status from "components/Status/Status";
import StatusWithDot from "components/StatusWithDot/StatusWithDot";
import TaskActionTooltip from "components/Tooltip/TaskActionTooltip";
import { IconButtonHolder } from "custom_modules/Jobs/tasksStyles";
import { CommImageNameComp } from "custom_modules/Members/CommonComponents";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import avatar5 from "../../assets/img/avatar_5.svg";
import arrowWhiteIcon from "../../assets/img/icons/arrow_right_white.svg";
import Chat from "../../assets/img/icons/chat.svg";
import duplicate from "../../assets/img/icons/copy_white.svg";
import delete2 from "../../assets/img/icons/delete_normal.svg";
import Pencil from "../../assets/img/icons/edit-2.svg";
import DropdownLoader from "../../components/DropdownLoader/DropdownLoader";
import FilterDropDownStyle from "../../components/DropdownStyle/FilterDropDownStyle";
import ComponentCircleLoader from "../../components/Loaders/ComponentCircleLoader";
import NoDataComponent from "../../components/NoDataComponent/NoDataComponent";
import Select from "../../components/ReactSelectDropdown";
import CommonTooltip from "../../components/Tooltip/CommonTooltip";
import {
  ActionSection,
  BudgetCollapseSection,
  ClientDeadlineGrid,
  ListUpperSection,
  ProjectDuplicateDiv,
  ProjectDuplicateIcon,
  ProjectItemCount,
  ProjectListItem,
  ProjectListSection,
  ProjectTableContainer,
  ProjectTableHeaderContainer,
  ProjectTitleDiv,
  TableItem,
  TableRowAndBudgetCollapseContainer,
} from "../../styledComponents/ProjectsNew";
import { ButtonIcon, PrimaryButton } from "../../styledComponents/buttons";
import {
  HoveredSection2,
  InnerDivTooltip,
  RoundHover,
  ToolTipContainer,
  TooltipText,
} from "../../styledComponents/clients";
import {
  ColoredText,
  CommonFlexIcon,
  CommonImage,
  CommonText,
  Container,
  FirstWordRound,
  TableText,
} from "../../styledComponents/common";
import { AssigneesManageImgTextGrid } from "../../styledComponents/createProject";
import {
  IntegrationIcon,
  IntegrationIconDiv,
} from "../../styledComponents/tasks";
import {
  DeadlineText,
  EditProjectButton,
  ExpandIcon,
  ProjectExpandButton,
  ProjectListStatusBadge,
} from "../Projects/projectsStyles";
import { CommFirstRoundLetterComp } from "../Teams/CommonComponents";
import ViewLess from "./ViewLess";

const WorkOrdersList = ({
  selectedOrganization,
  WorkOrderList,
  expandedWorkOrderId,
  setExpandedWorkOrderId,
  workOrderBudgetAndBillableIsLoading,
  workOrderBudgetAndBillable,
  isLoading,
  workOrderType,
  history,
  toggleDeleteModal,
  duplicateWorkOrder,
}) => {
  const [integrationTooltip, setIntegrationTooltip] = useState(null);
  const [selectIndex, setSelectIndex] = useState(-1);
  const [toolTip, setToolTip] = useState(-1);
  const { t } = useTranslation();
  // Dynamic labels based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";

  useEffect(() => {
    if (WorkOrderList && WorkOrderList.length > 0) {
      setExpandedWorkOrderId(WorkOrderList[0].id);
    }
  }, [WorkOrderList]);

  const handleDuplicateWorkOrder = workorder_id => {
    if (selectedOrganization && selectedOrganization.id) {
      const payload = {
        organization_id: selectedOrganization.id,
        workOrder_id: workorder_id,
        org_type: selectedOrganization?.type,
      };
      duplicateWorkOrder(payload);
    }
  };

  const handleDeleteProject = workorder_id => {
    toggleDeleteModal(workorder_id);
  };

  const toolTipChange = (value, index) => {
    setToolTip(value);
    setSelectIndex(index);
  };

  const handleExpandBudgetSection = work_order => {
    if (expandedWorkOrderId && expandedWorkOrderId === work_order) {
      setExpandedWorkOrderId(null);
    } else {
      setExpandedWorkOrderId(work_order);
    }
  };

  const columnsTemplate =
    orgType === "service"
      ? "1fr 0.8fr minmax(100px, 200px) minmax(100px, 200px) 1fr"
      : "300px 300px 200px 1fr";

  return (
    <Container style={{ paddingBottom: "20px" }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : (
        WorkOrderList &&
        WorkOrderList.length > 0 && (
          <>
            <ProjectTableHeaderContainer columns={columnsTemplate}>
              <TableItem>
                <TableText>
                  {t(orgType === "service" ? "job" : "project")}
                </TableText>
              </TableItem>

              {/* {orgType === "service" && (
                <TableItem>
                  <TableText>{t("customer")}</TableText>
                </TableItem>
              )} */}

              <TableItem>
                <TableText>{t("status")}</TableText>
              </TableItem>

              <TableItem>
                <TableText>{t("actions")}</TableText>
              </TableItem>
            </ProjectTableHeaderContainer>
            {WorkOrderList.map((work_order, index) => (
              <TableRowAndBudgetCollapseContainer
                isLastItem={index === WorkOrderList.length - 1}
                key={work_order.id}
              >
                <ProjectTableContainer
                  isLastItem={index === WorkOrderList.length - 1}
                  columns={columnsTemplate}
                >
                  <TableItem
                    style={{
                      gridTemplateColumns: "auto auto",
                      alignItems: "center",
                      gridColumnGap: "10px",
                    }}
                    onClick={() =>
                      orgType === "service"
                        ? history.push(`/user/details-job?id=${work_order.id}`)
                        : history.push(
                            `/user/details-project?id=${work_order.id}`,
                          )
                    }
                  >
                    <TableText
                      hoverPointer
                      hoverUnderline
                      margin="0 0 0 0"
                      fontWeight={
                        expandedWorkOrderId &&
                        expandedWorkOrderId === work_order.id &&
                        "600"
                      }
                    >
                      {work_order.name}
                    </TableText>
                    {work_order.integrations &&
                      work_order.integrations.length > 0 &&
                      work_order.integrations.map((integration, index) => {
                        return (
                          <IntegrationIconDiv
                            key={index}
                            onMouseEnter={() =>
                              setIntegrationTooltip(work_order.id)
                            }
                            onMouseLeave={() => setIntegrationTooltip(null)}
                          >
                            <IntegrationIcon
                              src={`https://cdn.apploye.com/integrations/icons/${integration}.svg`}
                              alt={integration}
                            />
                            {integrationTooltip &&
                              integrationTooltip === work_order.id && (
                                <CommonTooltip
                                  tooltipText={`${integration
                                    .charAt(0)
                                    .toUpperCase()}${integration.slice(1)}`}
                                  left="-32px"
                                  top="-30px"
                                  width="82px"
                                  height="26px"
                                />
                              )}
                          </IntegrationIconDiv>
                        );
                      })}
                  </TableItem>

                  {/* {orgType === "service" && (
                    <TableItem
                      hoverPointer
                      hoverUnderline
                      onClick={() =>
                        history.push(
                          `/user/customer-details?id=${work_order.client.id}`,
                        )
                      }
                    >
                      {work_order.client && (
                        <CommImageNameComp
                          imgSource={avatar5}
                          name={work_order.client.name}
                          size="36px"
                          fontSize="13px"
                          index={index}
                          color={work_order.client.color}
                          hoverUnderline
                          showAddDesignation={false}
                          designation={work_order.client.designation}
                          email={work_order.client.email}
                        />
                      )}
                    </TableItem>
                  )} */}

                  <TableItem >
                    <StatusWithDot status={work_order.status} />
                  </TableItem>

                  <TableItem>
                    {selectedOrganization &&
                    (selectedOrganization.role === "admin" ||
                      selectedOrganization.role === "owner") ? (
                      <CommonFlexIcon gap="0px">
                        <IconButtonHolder
                          onMouseEnter={() => toolTipChange(1, index)}
                          onMouseLeave={() => toolTipChange(-1)}
                          onClick={() =>
                            history.push(
                              `/user/edit-${
                                orgType === "service" ? "job" : "project"
                              }?id=${work_order.id}`,
                            )
                          }
                        >
                          <CommonImage src={Pencil} alt="pencil" size="24px" />
                          {selectIndex === index && toolTip === 1 && (
                            <TaskActionTooltip
                              toolTipText={t("edit_project")}
                            />
                          )}
                        </IconButtonHolder>

                        <IconButtonHolder
                          onMouseEnter={() => toolTipChange(2, index)}
                          onMouseLeave={() => toolTipChange(-1)}
                          onClick={() =>
                            handleDuplicateWorkOrder(work_order.id)
                          }
                        >
                          <CommonImage src={duplicate} alt="file" size="24px" />
                          {selectIndex === index && toolTip === 2 && (
                            <TaskActionTooltip toolTipText={t("duplicate")} />
                          )}
                        </IconButtonHolder>

                        <IconButtonHolder
                          onMouseEnter={() => toolTipChange(3, index)}
                          onMouseLeave={() => toolTipChange(-1)}
                          onClick={() => handleDeleteProject(work_order.id)}
                        >
                          <CommonImage src={delete2} alt="" size="25px" />
                          {selectIndex === index && toolTip === 3 && (
                            <TaskActionTooltip toolTipText={t("delete")} />
                          )}
                        </IconButtonHolder>
                      </CommonFlexIcon>
                    ) : (
                      <CommonText>-</CommonText>
                    )}
                  </TableItem>
                  {work_order.managed && (
                    <>
                      <TableItem rightAlign margin="0 10px 0 0">
                        <ProjectExpandButton
                          onClick={() =>
                            handleExpandBudgetSection(work_order.id)
                          }
                        >
                          <ExpandIcon
                            src={arrowWhiteIcon}
                            alt=""
                            open={
                              expandedWorkOrderId &&
                              expandedWorkOrderId === work_order.id
                            }
                          />
                        </ProjectExpandButton>
                      </TableItem>
                    </>
                  )}
                </ProjectTableContainer>

                {work_order.managed && (
                  <BudgetCollapseSection
                    open={
                      expandedWorkOrderId &&
                      expandedWorkOrderId === work_order.id
                    }
                  >
                    {expandedWorkOrderId &&
                    expandedWorkOrderId === work_order.id ? (
                      workOrderBudgetAndBillableIsLoading ? (
                        <DropdownLoader
                          loading
                          size={10}
                          padding="40px 0 0"
                          animated
                        />
                      ) : workOrderBudgetAndBillable &&
                        workOrderBudgetAndBillable.id &&
                        workOrderBudgetAndBillable.id === work_order.id ? (
                        <ViewLess
                          selectedOrganization={selectedOrganization}
                          work_order={workOrderBudgetAndBillable}
                        />
                      ) : null
                    ) : null}
                  </BudgetCollapseSection>
                )}
              </TableRowAndBudgetCollapseContainer>
            ))}
          </>
        )
      )}
      {!isLoading && WorkOrderList && WorkOrderList.length === 0 && (
        <NoDataComponent
          title={t(
            orgType === "service" ? "no_jobs_found" : "no_project_found",
          )}
        />
      )}
    </Container>
  );
};

export default WorkOrdersList;
